import React, { useState, useEffect } from 'react';

const PromptModal = ({ isOpen, title, defaultValue, onConfirm, onCancel }) => {
  const [inputValue, setInputValue] = useState(defaultValue || '');

  // Update input value when defaultValue changes
  useEffect(() => {
    if (isOpen && defaultValue) {
      setInputValue(defaultValue);
    }
  }, [isOpen, defaultValue]);

  const handleConfirm = () => {
    onConfirm(inputValue);
    setInputValue('');
  };

  const handleCancel = () => {
    onCancel();
    setInputValue('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleConfirm();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '8px',
        boxShadow: 'var(--standard-box-shadow)',
        minWidth: '400px',
        maxWidth: '500px'
      }}>
        <h3 style={{
          margin: '0 0 16px 0',
          fontSize: '18px',
          fontWeight: '600',
          color: 'var(--text-color)',
          textAlign: 'center'
        }}>
          {title}
        </h3>
        
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyPress}
          autoFocus
          style={{
            width: '100%',
            padding: '12px',
            border: '1px solid var(--border-color)',
            borderRadius: '4px',
            fontSize: '14px',
            marginBottom: '20px',
            boxSizing: 'border-box'
          }}
        />
        
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '12px'
        }}>
          <button
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              backgroundColor: '#f5f5f5',
              color: '#666',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Cancel
          </button>
          
          <button
            onClick={handleConfirm}
            disabled={!inputValue.trim()}
            style={{
              padding: '10px 20px',
              backgroundColor: inputValue.trim() ? 'var(--color1)' : 'var(--color-disabled)',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: inputValue.trim() ? 'pointer' : 'not-allowed',
              fontSize: '14px',
              fontWeight: '500',
              opacity: inputValue.trim() ? 1 : 0.6
            }}
          >
            Share Questions
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromptModal;
